import {
  ChevronDown,
  Columns3,
  Download,
  Filter,
  ListOrdered,
  Save,
  Trash2,
  Target,
} from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { RANDURI_PE_PAGINA } from "@/utils/targetareRaport";

export type MeniuActiuniProps = {
  randuriPePagina: number;
  poateSterge: boolean;
  areSelectie: boolean;
  onColoane: () => void;
  onFiltru: () => void;
  onRanduriPePagina: (n: number) => void;
  onSalveaza: () => void;
  onSterge: () => void;
  onDescarca: (format: "csv" | "xlsx", doarSelectate: boolean) => void;
  actiuniSelectie?: { eticheta: string; onClick: () => void }[];
};

export function MeniuActiuni({
  randuriPePagina,
  poateSterge,
  areSelectie,
  onColoane,
  onFiltru,
  onRanduriPePagina,
  onSalveaza,
  onSterge,
  onDescarca,
  actiuniSelectie = [],
}: MeniuActiuniProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" className="h-9">
          Actions
          <ChevronDown className="ml-2 h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-60">
        <DropdownMenuItem onClick={onColoane}>
          <Columns3 className="mr-2 h-4 w-4" />
          Coloane…
        </DropdownMenuItem>
        <DropdownMenuItem onClick={onFiltru}>
          <Filter className="mr-2 h-4 w-4" />
          Filtru…
        </DropdownMenuItem>
        <DropdownMenuSub>
          <DropdownMenuSubTrigger>
            <ListOrdered className="mr-2 h-4 w-4" />
            Rânduri pe pagină
          </DropdownMenuSubTrigger>
          <DropdownMenuSubContent>
            <DropdownMenuRadioGroup
              value={String(randuriPePagina)}
              onValueChange={(v) => onRanduriPePagina(Number(v))}
            >
              {RANDURI_PE_PAGINA.map((n) => (
                <DropdownMenuRadioItem key={n} value={String(n)}>
                  {n}
                </DropdownMenuRadioItem>
              ))}
            </DropdownMenuRadioGroup>
          </DropdownMenuSubContent>
        </DropdownMenuSub>
        {actiuniSelectie.length > 0 && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuLabel>Selecție</DropdownMenuLabel>
            {actiuniSelectie.map((a) => (
              <DropdownMenuItem
                key={a.eticheta}
                onClick={a.onClick}
                disabled={!areSelectie}
              >
                <Target className="mr-2 h-4 w-4" />
                {a.eticheta}
              </DropdownMenuItem>
            ))}
          </>
        )}
        <DropdownMenuSeparator />
        <DropdownMenuLabel>Raport</DropdownMenuLabel>
        <DropdownMenuItem onClick={onSalveaza}>
          <Save className="mr-2 h-4 w-4" />
          Salvează raportul…
        </DropdownMenuItem>
        <DropdownMenuItem onClick={onSterge} disabled={!poateSterge}>
          <Trash2 className="mr-2 h-4 w-4" />
          Șterge raportul
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuSub>
          <DropdownMenuSubTrigger>
            <Download className="mr-2 h-4 w-4" />
            Descarcă
          </DropdownMenuSubTrigger>
          <DropdownMenuSubContent>
            <DropdownMenuItem onClick={() => onDescarca("csv", false)}>
              CSV (rândurile filtrate)
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => onDescarca("xlsx", false)}>
              Excel (rândurile filtrate)
            </DropdownMenuItem>
            <DropdownMenuItem
              onClick={() => onDescarca("csv", true)}
              disabled={!areSelectie}
            >
              CSV (rândurile selectate)
            </DropdownMenuItem>
            <DropdownMenuItem
              onClick={() => onDescarca("xlsx", true)}
              disabled={!areSelectie}
            >
              Excel (rândurile selectate)
            </DropdownMenuItem>
          </DropdownMenuSubContent>
        </DropdownMenuSub>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
